module.exports = "https://static.energy5.com/_next/static/images/retailEnergyBg-0e0c3b07357a898466b7e8f773b5c601.webp";